module.exports = __webpack_public_path__ + "static/img/icon_matron4.8069830f.png";